import React, {Component} from 'react';
import './index.scss';

interface ToggledContentProps {
  visible: boolean;
  className?: string;
}

interface ToggledContentState {
  height: number|null;
}

export class ToggledContent extends Component<ToggledContentProps, ToggledContentState> {
  state = {
    height: null
  };

  private content: HTMLDivElement|null = null;

  componentDidMount(): void {
    if(this.props.visible) {
      this.updateHeight();
    }
  }

  componentDidUpdate(prevProps: Readonly<ToggledContentProps>, prevState: Readonly<ToggledContentState>, snapshot?: any): void {
    if(this.props.visible) {
      this.updateHeight();
    }
  }

  onContentRendered = (el:HTMLDivElement|null) => {
    this.content = el;
    if(this.props.visible) {
      this.updateHeight();
    }
  };

  updateHeight() {
    const newHeight = this.content ? this.content.getBoundingClientRect().height : 0;
    const oldHeight = this.state.height;
    if(oldHeight === null || Math.abs(newHeight - oldHeight) >= 1) {
      this.setState({height: newHeight});
    }
  }

  render() {
    let fullClassName = 'toggled-content';
    fullClassName += ' ' + (this.props.visible ? 'visible' : 'hidden');
    if (this.props.className) {
      fullClassName += ' ' + this.props.className;
    }
    let marginTop = '0px';
    if (!this.props.visible) {
      marginTop = this.state.height ? -this.state.height! + 'px' : '-10000px';
    }
    return <div className={fullClassName}>
      <div className="content" ref={this.onContentRendered} style={{marginTop: marginTop}}>
        { this.props.children }
      </div>
    </div>;
  }
}